export const goalStatusValues = {
	ON_TRACK: 'ON_TRACK',
	AT_RISK: 'AT_RISK',
	OFF_TRACK: 'OFF_TRACK',
	PENDING: 'PENDING',
	DONE: 'DONE',
	CANCELLED: 'CANCELLED',
	PAUSED: 'PAUSED',
	ARCHIVED: 'ARCHIVED',
	COMPLETED: 'COMPLETED',
} as const;

export const goalStatuses = [
	'archived',
	'at_risk',
	'cancelled',
	'done',
	'off_track',
	'on_track',
	'paused',
	'pending',
] as const;

export type GoalStateValue = (typeof goalStatuses)[number];

export type State = {
	score: number | null;
	value: GoalStateValue;
};
